import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLineReceptionList } from '../../store/line/getLineReceptionListSlice';
import customerPostLineReceptionsApi from '../../apis/customer/customerPostLineReceptionsApi';
import LineReceptionWrapper from '../../components/lineReception/lineReceptionWrapper';

function LineReceptionContainer(props) {
  const {
    selectCustomer,
    page,
    setPage,
    rowsPerPage,
    setRowPages,
    selectedUserId,
  } = props;
  const dispatch = useDispatch();
  const displayTotalCount = selectCustomer ? selectCustomer.length : 0;
  const list = useSelector((state) => state.receptionList.responseParams);
  const requestParams = useSelector((state) => state.receptionList.initialRequestParams);
  const setCustomers = useCallback(async () => {
    const customerIdList = selectCustomer.map((customer) => {
      return customer.customerId;
    });

    if (selectCustomer.length === 0) {
      dispatch(getLineReceptionList({ data: { lineReceptions: [] } }));
      return;
    }
    const postDatanewParams = {
      customerIds: customerIdList,
      limit: rowsPerPage,
      offset: requestParams.offset,
      userId: selectedUserId,
    };

    const customersList = await customerPostLineReceptionsApi(postDatanewParams);
    dispatch(getLineReceptionList(customersList));
  }, [selectCustomer, requestParams.offset, rowsPerPage, dispatch]);

  useEffect(() => {
    setCustomers();
  }, [setCustomers]);

  return (
    <LineReceptionWrapper
      list={list || []}
      count={displayTotalCount}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowPages={setRowPages}
    />
  );
}

export default LineReceptionContainer;
